import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {contentStyle} from './index.style'
import Breadcrumbs from '../breadcrumbs'
import PropTypes from 'prop-types'

const LeftNavLayout = ({sidebar, children}) => {
    const [breadcrumbData, setBreadcrumbData] = React.useState({})
    const extraProps = {breadcrumbData, setBreadcrumbData}

    return (
        <>
            <Breadcrumbs breadcrumbData={breadcrumbData} />
            <Box sx={contentStyle}>
                <aside className="leftnav">{sidebar}</aside>
                <main className="content">{React.cloneElement(children, extraProps)}</main>
            </Box>
        </>
    )
}

LeftNavLayout.propTypes = {
    sidebar: PropTypes.node,
    children: PropTypes.node
}

export default LeftNavLayout
